import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
import { usePriceConfig } from './PriceContext';
export function BonusSection() {
  const price = usePriceConfig();
  const bonuses = [{
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/20260216_1210_Image_Generation_simple_compose_01khk29zj4eamaza16ty760a5q_1.webp?v=1771243363',
    title: 'Muebles Plegables de Alta Demanda REAL',
    description: 'Sumamos modelos funcionales adicionales que amplían tus habilidades más allá de lo plegable.',
    value: 19.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/20260216_1207_Image_Generation_simple_compose_01khk24ps2faybyzk2j22jjaj8_1.webp?v=1771240805',
    title: 'Acabados y Terminaciones PRemium',
    description: 'Aprenderás a sellar y barnizar tus muebles para lograr acabados resistentes y profesionales',
    value: 9.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/20260216_1227_Image_Generation_simple_compose_01khk38skvef8b3ja29adw2x7v_1.webp?v=1771243405',
    title: 'Guía de Herramientas Indispensables',
    description: 'Las herramientas correctas. Sin errores. Sin gasto inútil.',
    value: 7.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_23_1.webp?v=1771243859',
    title: 'Calculadora de Rentabilidad',
    description: 'Aprenderás a calcular el costo de tus materiales y obtener automáticamente el precio de venta correcto.',
    value: 14.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/20260216_1208_Image_Generation_simple_compose_01khk26kqgfc8ace4fqr3dyy0q_1.webp?v=1771243382',
    title: 'Plan Maestro de Negocio Rentable',
    description: 'Transforma tu pasión en una marca profesional. Incluye guía para definir tu nombre, crear fotos atractivas y posicionarte en redes.',
    value: 19.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/20260216_1209_Image_Generation_simple_compose_01khk273gxf9v904h28ftpjnk7_1.webp?v=1771243557',
    title: 'Protocolo de seguridad profesional',
    description: 'Protege tu cuerpo mientras trabajas. Aprende posturas correctas y técnicas para evitar molestias y lesiones.',
    value: 7.99
  }, {
    image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_22_1.webp?v=1771243792',
    title: 'Planos Pro de Muebles de Melamina',
    description: 'Modelos listos para construir, con medidas precisas y cortes optimizados para ampliar tu catálogo y fabricar piezas profesionales desde casa.',
    value: 19.99
  }];
  return <section id="bonus-section" className="py-8 md:py-16 px-4 bg-leather" data-id="element-2">
      <div className="max-w-5xl mx-auto" data-id="element-3">
        <div className="bg-metal border-2 md:border-8 border-[#8B5A2B] p-1 md:p-2 shadow-[0_0_60px_rgba(139,90,43,0.4)] mb-6 md:mb-8" data-id="element-4">
          <div className="bg-[#111111] p-3 md:p-8 border-2 md:border-4 border-[#6F6F6F]" data-id="element-5">
            <div className="text-center mb-6 md:mb-12" data-id="element-6">
              <Gift className="w-12 md:w-20 h-12 md:h-20 text-[#8B5A2B] mx-auto mb-3 md:mb-6" data-id="element-7" />
              <h2 className="text-2xl md:text-5xl lg:text-6xl font-black text-[#E4D6B5] mb-2 md:mb-4 uppercase tracking-tight" data-id="element-8">
                Reclama Estos 7 Bonos Exclusivos Si Ordenas Hoy
              </h2>
              <p className="text-sm md:text-xl text-[#C8B894] font-semibold" data-id="element-9">
                Si entras hoy, te daré 7 bonos especiales por tiempo limitado…
              </p>
            </div>

            {/* Bonuses Grid - last item centered when odd on mobile */}
            <div className="grid grid-cols-2 md:grid-cols-1 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-10">
              {bonuses.map((bonus, index) => <div key={index} className={`bg-metal border-2 md:border-4 border-[#6F6F6F] shadow-[0_4px_0_0_#0a0a0a] md:shadow-[0_6px_0_0_#0a0a0a] overflow-hidden${index === bonuses.length - 1 && bonuses.length % 2 !== 0 ? ' col-span-2 md:col-span-1 max-w-[calc(50%-6px)] mx-auto w-full' : ''}`} data-id="element-11">
                  <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-6 p-2 md:p-6" data-id="element-12">
                    <div className="w-full md:w-32 lg:w-40 flex-shrink-0" data-id="element-13">
                      <div className="aspect-square w-full bg-[#111111] border-2 border-[#6F6F6F] overflow-hidden" data-id="element-14">
                        <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-15" />
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-16">
                      <h3 className="text-xs md:text-2xl font-black text-[#E4D6B5] mb-1 md:mb-3 uppercase tracking-wide" data-id="element-17">
                        BONO #{index + 1}: {bonus.title}
                      </h3>
                      <p className="text-[10px] md:text-lg text-[#C8B894] leading-relaxed mb-1 md:mb-4 font-semibold" data-id="element-18">
                        {bonus.description}
                      </p>
                      {/* Localized bonus item price */}
                      <p className="text-xs md:text-xl font-bold text-[#E4D6B5]" data-id="element-19">
                        <span className="line-through text-[#6F6F6F]" data-id="element-20">
                          {bonus.value.toFixed(2)}
                          {price.itemSuffix}
                        </span>{' '}
                        — <span className="text-[#8B5A2B]" data-id="element-21">¡GRATIS!</span>
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>

            {/* Total Value Box */}
            <div className="bg-wood-grain p-4 md:p-10 border-2 md:border-4 border-[#6F6F6F] shadow-[0_4px_0_0_#6F6F6F] md:shadow-[0_8px_0_0_#6F6F6F] text-center" data-id="element-22">
              <p className="text-base md:text-2xl font-bold text-[#E4D6B5] mb-2 uppercase tracking-wider" data-id="element-23">
                Valor Total de los Bonos:
              </p>
              {/* Localized bonus total */}
              <p className="text-3xl md:text-6xl lg:text-7xl font-black text-[#E4D6B5] mb-2 drop-shadow-[0_4px_8px_rgba(0,0,0,0.9)]" data-id="element-24">
                {price.bonusTotalDisplay}
              </p>
              <p className="text-xl md:text-4xl font-black text-[#E4D6B5] uppercase tracking-wide" data-id="element-25">
                ¡TODOS GRATIS HOY!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-industrial mt-8 md:mt-16" data-id="element-26"></div>
    </section>;
}